export function getUnitPrefixPatterns(): Record<string, RegExp> {
  return {
    PENTHOUSE: /\b(?:UNIT\s+)?(?:PENTHOUSE|PH)[-\s]*(\d+[A-Z]*)\b/i,
    UNIT: /\bUNIT\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    APT: /\bAPT\.?\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    APARTMENT: /\bAPARTMENT\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    SUITE: /\bSUITE\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    STE: /\bSTE\.?\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    POUND: /\#\s*([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    SPACE: /\bSPACE\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    BUILDING: /\bBLDG\.?\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    FLOOR: /\bFL\.?\s+([A-Z0-9][-A-Z0-9]*[A-Z0-9]|\d+[A-Z]?)\b/i,
    IMPLICIT: /\b\d+\s+(\d+[A-Z]?)\b(?=,|\s|$)/,
    COMMA_UNIT: /\b(\d+[A-Z]?),\s/,
    PH_STANDALONE: /\bPH[-\s]*(\d+[A-Z]*)\b/i
  };
} 